import React, { useRef } from "react";
import { withApollo } from "react-apollo";
import { useSelector } from "react-redux";
import { signOut } from "../utils/signout";
import IconForApp from "../icons/IconForApp";
import { displayNameSelector } from "../features/user/redux/selectors";
import AppSwitcher from "./AppSwitch";
import { OwcButton, OwcDoubleGlobalArea, OwcIconButton, OwcPopover, OwcTypography } from "@one/react";
import styles from "./AppBar.module.scss";
import { NotificationCounter } from "@digitallab/grid-common-frontend-components";
import { useHistory, useLocation } from "react-router-dom";
import Banner from "./Banner";
import UserProfile from "./UserProfile";

const Appbar = ({ client, landingPageAppSyncClient }) => {
  const location = useLocation();
  const history = useHistory();
  const user = useSelector((store) => store.user);
  const userId = useSelector((state) => state.user.user);
  const name = useSelector((store) => displayNameSelector(store));
  const isTvMode = useSelector((state) => state?.bookingInstruments?.isTvMode);
  const email = user.email;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isBookingAdmin = Array.isArray(user?.roles) && user.roles.some(r => r === "BookingAdmin");
  const handleNotificationViewAll = () => {
    history.push("/notifications");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const logoLetter = email?.charAt(0);
  const infoInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const popoverElement = useRef(null);

  if (isTvMode) return null;

  return (
    <>
      <OwcDoubleGlobalArea style={{ zIndex: 510 }}>
        <div slot="primary" style={{
          justifyContent: "space-between",
          border: "none",
          filter: "none",
          'WebkitFilter': 'none',
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.40)"
        }}>
          <div
            style={{
              paddingLeft: "16px",
              display: "flex",
              width: "30%",
              alignItems: "center",
            }}
          >
            <IconForApp />
            <OwcTypography style={{ paddingLeft: "16px" }} variant="subtitle1">
              Equipment Booking
            </OwcTypography>
          </div>
          <Banner />
          <div style={{ display: "flex", alignItems: "center" }}>
            <OwcTypography variant="caption">{name}</OwcTypography>
            <OwcIconButton
              data-testid="app-bar-user-info-user"
              id="popover-anchor-for-top-bar"
              hasFocus={anchorEl !== null}
              onClick={handleClick}
              style={{ marginRight: "8px" }}
              flat
              icon="user"
            />

            <AppSwitcher data-testid="app-bar-app-switcher" client={client} />
            <NotificationCounter
              handleNotificationViewAll={handleNotificationViewAll}
              landingPageClient={landingPageAppSyncClient}
              isNotificationHighlighted={location.pathname.indexOf("notification") === 1}
              userId={userId}
            />
            <OwcIconButton
              style={{ marginRight: "26px" }}
              flat
              data-testid="help-button"
              onClick={() => infoInNewTab(process.env.REACT_APP_INFO_URL)}
              icon="circle_info"
            />
            <OwcIconButton
              type="legacy"
              style={{
                margin: "0 8px",
                color: "var(--one-color-interaction-default-brand-1)",
                width: "48px",
              }}
              icon="roche_logo"
              flat
            />
          </div>
        </div>
      </OwcDoubleGlobalArea>
      <OwcPopover
        ref={popoverElement}
        data-testid="popover-user-menu"
        anchor="popover-anchor-for-top-bar"
        id="popover-anchor-for-top-bar-popover"
        anchor-position="bottom-start"
        visible={open}
        disable-portal={true}
        onClickOutside={() => {
          handleClose();
        }}
        className={styles.appbarPopoverWidth}
      >
        <div className={styles.UserInfoSection}>
          <span className={styles.LogoLetter}>{logoLetter}</span>
          <OwcTypography variant="subtitle1">{name}</OwcTypography>
          <OwcTypography variant="body2">{email}</OwcTypography>
        </div>
        <UserProfile user={user} isBookingAdmin={isBookingAdmin} />
        <div className={styles.appbarLogoutContainer}>
          <OwcButton
            data-testid="popover-user-menu-footer-section-logout"
            onClick={() => {
              handleClose();
              signOut(client);
            }}
            variant="secondary"
          >
            Logout
          </OwcButton>
        </div>
      </OwcPopover>
    </>
  );
};

export default withApollo(Appbar);
